import { useQuery } from "@tanstack/react-query";
import type {
  GeoCountriesResponse,
  GeoSubdivisionsResponse,
} from "@guestbook/shared";
import { apiFetch, type ApiClientError } from "@/shared/lib/api";

const GEO_KEY = "geo" as const;

// The geo reference data is immutable for a deploy, so we never refetch within a
// session (staleTime: Infinity). The list endpoints are unauthenticated, so
// these work the same in the authed app and the public share form.

export function useCountries() {
  return useQuery<GeoCountriesResponse, ApiClientError>({
    queryKey: [GEO_KEY, "countries"],
    queryFn: () => apiFetch<GeoCountriesResponse>("/geo/countries"),
    staleTime: Infinity,
  });
}

export function useCountrySubdivisions(countryCode: string | null | undefined) {
  return useQuery<GeoSubdivisionsResponse, ApiClientError>({
    queryKey: [GEO_KEY, "subdivisions", countryCode],
    queryFn: () =>
      apiFetch<GeoSubdivisionsResponse>(
        `/geo/countries/${encodeURIComponent(countryCode!)}/subdivisions`,
      ),
    enabled: Boolean(countryCode),
    staleTime: Infinity,
  });
}
